<template>
	<section class="dp-layout">

		<section class="dp-left">
			<DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
		</section>

		<section class="dp-right">
			<!--工具条-->
			<toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
			<div class="dp-dept-hint">
				<span class="dp-dept-hint__label">所属机构</span>
				<span class="dp-dept-hint__value">{{ currentDepartmentName || '全部' }}</span>
			</div>
			<div class="all_page_border">
								<el-table :data="users" v-loading="listLoading" ref="table" style="width: 100%"
					@selection-change="handleSelectionChange" @select="dialogCheck" @row-click="selectCurrentRow">

					<el-table-column type="selection"> </el-table-column>
					<el-table-column prop="Title" label="标题" width></el-table-column>
						<el-table-column prop="DepartmentName" label="部门" :formatter="formatDepartmentNameCol" width></el-table-column>
					<el-table-column prop="CoverFile" label="封面文件" align="center" header-align="center">
						<template slot-scope="scope">
              <oss-media-thumbs :media="scope.row.CoverFile" thumb-width="70px" />
						</template>
					</el-table-column>

					<el-table-column prop="VideoFile" label="视频文件" width>
						<template slot-scope="scope">
							<div>
								<span class="video-browse-link"
									style="color:var(--btn-primary, #2563eb);cursor:pointer;text-decoration:underline;"
									@click.stop="handleVideoClick(scope.row.VideoFile)">点击浏览</span>
							</div>
						</template>
					</el-table-column>

					<el-table-column prop="Type" label="类型" width>
						<template slot-scope="scope">
							<el-tag :type="scope.row.Type == 1 ? 'primary' : 'warning'" disable-transitions>
								{{ scope.row.Type == 1 ? '通知' : '资讯' }}
							</el-tag>
						</template>
					</el-table-column>

					<el-table-column prop="IsPublish" label="是否发布" width="">
						<template slot-scope="scope">
							<el-tag :type="scope.row.IsPublish == 1 ? 'success' : 'info'" disable-transitions>{{
								scope.row.IsPublish == 1 ? '是' : '否' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="Sort" label="排序" width> </el-table-column>
					<el-table-column prop="CreateBy" label="创建人" width>

					</el-table-column>

					<el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime"
						width></el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
						:page-size="PageSize" :total="total" style="float: right"></el-pagination>
				</el-col>
			</div>
			<!--编辑界面-->
			<el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible"
				:close-on-click-modal="false">
				<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
					<el-form-item label="标题" prop="Title">
						<el-input v-model="editForm.Title" auto-complete="off"></el-input>
					</el-form-item>

					<el-form-item label="类型" prop="Type">
						<el-radio-group v-model="editForm.Type">
							<el-radio :label="1">通知</el-radio>
							<el-radio :label="2">资讯</el-radio>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="所属机构" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="editForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="cascaderKey"
							:props="$deptCascaderProps"></el-cascader>
					</el-form-item>

					<el-form-item label="封面" prop="CoverFile">
						<el-upload class="avatar-uploader" action="#" :auto-upload="false"
							:show-file-list="false" :on-change="handleCoverChange"
							accept=".png,.jpg,.jpeg,.gif,.bmp,.webp">
							<img v-if="deferredImageDisplay('cover', imageUrl)" v-oss-src="deferredImageDisplay('cover', imageUrl)" class="avatar" />
							<i v-if="!deferredImageDisplay('cover', imageUrl)" class="el-icon-plus avatar-uploader-icon"></i>
							<div class="avatar-uploader-tip" v-if="!deferredImageDisplay('cover', imageUrl)">
								请选择10:6的图片
							</div>
						</el-upload>
					</el-form-item>

					<el-form-item label="视频文件" prop="VideoFile">
						<el-upload class="avatar-uploader" action="#" :accept="'video/*'" :show-file-list="false"
							:before-upload="beforeVideoUpload" :http-request="customVideoUpload">
							<video v-if="videoPreviewSrc" :src="videoPreviewSrc" class="avatar" controls />
							<i v-if="!videoUrl && !imageLoadding" class="el-icon-plus avatar-uploader-icon"></i>
							<i v-if="!videoUrl && imageLoadding" class="el-icon-loading avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>

					<el-form-item label="是否发布" prop="IsPublish">
						<el-switch v-model="editForm.IsPublish"></el-switch>
					</el-form-item>
					<el-form-item label="排序" prop="Sort">
						<el-input v-model="editForm.Sort" autocomplete="off" type="number"></el-input>
					</el-form-item>
					<el-form-item label="内容" prop="Content">
						<quill-editor v-model="editForm.Content" ref="myQuillEditor" :options="editorOption"
							@blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
							@change="onEditorChange($event)">
						</quill-editor>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="editFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
				</div>
			</el-dialog>

			<!--新增界面-->
			<el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
				<el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
					<el-form-item label="标题" prop="Title">
						<el-input v-model="addForm.Title" auto-complete="off"></el-input>
					</el-form-item>

					<el-form-item label="类型" prop="Type">
						<el-radio-group v-model="addForm.Type">
							<el-radio :label="1">通知</el-radio>
							<el-radio :label="2">资讯</el-radio>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="所属机构" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="addForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="cascaderKey"
							:props="$deptCascaderProps"></el-cascader>
					</el-form-item>

					<el-form-item label="封面" prop="CoverFile">
						<el-upload class="avatar-uploader" action="#" :auto-upload="false"
							:show-file-list="false" :on-change="handleCoverChange"
							accept=".png,.jpg,.jpeg,.gif,.bmp,.webp">
							<img v-if="deferredImageDisplay('cover', imageUrl)" v-oss-src="deferredImageDisplay('cover', imageUrl)" class="avatar" />
							<i v-if="!deferredImageDisplay('cover', imageUrl)" class="el-icon-plus avatar-uploader-icon"></i>
							<div class="avatar-uploader-tip" v-if="!deferredImageDisplay('cover', imageUrl)">
								请选择10:6的图片
							</div>
						</el-upload>
					</el-form-item>

					<el-form-item label="视频文件" prop="VideoFile">
						<el-upload class="avatar-uploader" action="#" :accept="'video/*'" :show-file-list="false"
							:before-upload="beforeVideoUpload" :http-request="customVideoUpload">
							<video v-if="videoPreviewSrc" :src="videoPreviewSrc" class="avatar" controls />
							<i v-if="!videoUrl && !imageLoadding" class="el-icon-plus avatar-uploader-icon"></i>
							<i v-if="!videoUrl && imageLoadding" class="el-icon-loading avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>

					<el-form-item label="是否发布" prop="IsPublish">
						<el-switch v-model="addForm.IsPublish"></el-switch>
					</el-form-item>
					<el-form-item label="排序" prop="Sort">
						<el-input v-model="addForm.Sort" autocomplete="off" type="number"></el-input>
					</el-form-item>
					<el-form-item label="内容" prop="Content">
						<quill-editor v-model="addForm.Content" ref="myQuillEditor" :options="editorOption"
							@blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
							@change="onEditorChange($event)">
						</quill-editor>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="addFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
				</div>
			</el-dialog>

			<!-- 视频上传进度 -->
			<el-dialog
				title="视频上传中"
				:visible.sync="videoUploading"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				:show-close="false"
				width="400px"
				append-to-body
			>
				<el-progress :percentage="videoUploadProgress" :stroke-width="16"></el-progress>
				<div style="text-align:center;margin-top:12px;color:#909399;font-size:13px;">请勿关闭或切换页面</div>
			</el-dialog>

			<el-upload style="display: none;" name="Files" class="quill-upload" :on-success="quillSuccess"
				accept=".png, .jpg, .jpeg" :data="$ossUploadData('DeptVideoRecord')" :action="BaseApiUrl + '/images/Upload/Pic'">
				<i class="el-icon-upload"></i>
			</el-upload>

			<!-- 放大视频弹窗 -->
			<el-dialog :visible.sync="videoDialogVisible" width="60%" top="5vh" :close-on-click-modal="true" center
				@close="handleVideoDialogClose">
				<video v-if="currentVideoUrl" :src="currentVideoUrl" controls autoplay
					style="width:100%;height:60vh;background:#000"></video>
			</el-dialog>

		</section>
	</section>
</template>

<script>
import util from '../../../util/date'
import { getDeptVideoRecordListPage, editDeptVideoRecord, addDeptVideoRecord, deleteDeptVideoRecord } from '../../api/modules/misc';
import deptCascaderSelectionMixin from '../../mixins/deptCascaderSelectionMixin'
import { BaseApiUrl } from '../../api/base';
import {
	attachLocalVideoFile,
	revokeLocalVideoPreview,
	ensureVideoUploaded,
	beginVideoUploadProgress,
	endVideoUploadProgress,
	createVideoUploadProgressHandlers,
} from '../../utils/ossVideoUpload'
import { resolveMediaUrl, resolvePlayableMediaUrl, applyPlayableMediaUrl } from '../../utils/mediaUrl'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
	['blockquote', 'code-block'], // 引用，代码块
	[{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
	[{ list: 'ordered' }, { list: 'bullet' }], // 列表
	[{ script: 'sub' }, { script: 'super' }], // 上下标
	[{ indent: '-1' }, { indent: '+1' }], // 缩进
	[{ direction: 'rtl' }], // 文本方向
	[{ size: ['small', false, 'large', 'huge'] }], // 字体大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
	[{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
	[{ align: [] }], // 对齐方式
	['clean'], // 清除字体样式
	['image'], // 上传图片
]
export default {
	mixins: [deptCascaderSelectionMixin],
	components: { Toolbar, DepartmentPane },
	data() {
		return {
			cascaderKey: 0,
			props: { checkStrictly: true },
			BaseApiUrl: BaseApiUrl, //网络前缀
				searchList: [
				{
					label: '名称',
					key: 'name',
				},
			],
			imageUrl: '',
			imageLoadding: false,
			videoUrl: '',
			videoPlaySrc: '',
			editorOption: {
				placeholder: '请在这里输入',
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							// 重写点击组件上的图片按钮要执行的代码
							image: function (value) {
								if (value) {
									document.querySelector('.quill-upload .el-icon-upload').click()
								} else {
									this.quill.format("image", false);
								}
							}
						}
					}
				},
			},
			buttonList: [],
			currentRow: null,
			options: [],
			filters: {},
			users: [],
			total: 0,
			page: 1,
			PageSize: 10,
			listLoading: false,
			isResouceShow: 0,
			addDialogFormVisible: false,
			editFormVisible: false, //编辑界面是否显示
			editLoading: false,
			editFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				Content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
			},
			//编辑界面数据
			editForm: {
				Id: 0,
				Title: '',           // 标题
				Content: '',         // 内容
				Type: 1,             // 类型，默认1通知
				IsPublish: true,     // 是否发布
				Sort: 1,             // 排序
				VideoFile: '',       // 视频文件（上传后赋值）
				CoverFile: '',       // 封面文件（上传后赋值）
				Dids: [],
				DepartmentId: 0,
			},

			addFormVisible: false, //新增界面是否显示
			addLoading: false,
			addFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				Content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
			},
			//新增界面数据
			addForm: {
				Title: '',           // 标题
				Content: '',         // 内容
				Type: 1,             // 类型，默认1通知
				IsPublish: true,     // 是否发布
				Sort: 1,             // 排序
				VideoFile: '',       // 视频文件（上传后赋值）
				CoverFile: '',       // 封面文件（上传后赋值）
				Dids: [],
				DepartmentId: 0,
			},
			DepartmentId: 0,
			SchoolId: 0,
			multipleSelection: [],
			currentDepartmentName: '',
			videoDialogVisible: false,
			currentVideoUrl: '',
			pendingVideoFile: null,
			pendingVideoPreviewUrl: '',
			videoUploading: false,
			videoUploadProgress: 0,

		}
	},
	computed: {
		videoPreviewSrc() {
			if (this.pendingVideoPreviewUrl) return this.pendingVideoPreviewUrl
			return this.videoPlaySrc || this.resolveMediaUrl(this.videoUrl)
		}
	},
	methods: {
		resolveMediaUrl,
		async refreshVideoPlaySrc() {
			if (this.pendingVideoPreviewUrl) {
				this.videoPlaySrc = ''
				return
			}
			await applyPlayableMediaUrl(this, 'videoPlaySrc', this.videoUrl, this.DepartmentId)
		},
		customVideoUpload(req) {
			const { file, onSuccess, onError } = req
			if (!this.DepartmentId) {
				this.$message.warning('请先选择部门')
				onError(new Error('未选择部门'))
				return
			}
			this.revokePendingVideoLocal()
			const local = attachLocalVideoFile(file)
			this.pendingVideoFile = local.pendingVideoFile
			this.pendingVideoPreviewUrl = local.pendingVideoPreviewUrl
			this.imageLoadding = false
			onSuccess({ success: true, response: '' })
		},
		revokePendingVideoLocal() {
			revokeLocalVideoPreview(this.pendingVideoPreviewUrl)
			this.pendingVideoFile = null
			this.pendingVideoPreviewUrl = ''
			this.videoPlaySrc = ''
		},

		handleVideoDialogClose() {
			this.currentVideoUrl = '';
		},
		async handleVideoClick(videoPath) {
			if (!videoPath) return
			try {
				this.currentVideoUrl = await resolvePlayableMediaUrl(videoPath, this.DepartmentId)
			} catch (e) {
				this.$message.error((e && e.message) || '无法播放视频')
				return
			}
			this.videoDialogVisible = true
		},
		onEditorBlur() {
			//失去焦点事件
		},
		onEditorFocus() {
			//获得焦点事件
		},
		onEditorChange() {
			//内容改变事件
		},
		dialogCheck(selection, row) {
			this.currentRow = null
			this.$refs.table.clearSelection()
			if (selection.length === 0) {
				return
			}
			if (row) {
				this.selectCurrentRow(row)
			}
		},
		selectCurrentRow(val) {
			console.log(val)
			if (val) {
				this.currentRow = val
				this.$refs.table.clearSelection()
				this.$refs.table.toggleRowSelection(val, true)
			}
		},
		treeNodeClick(data, node, component) {
			this.DepartmentId = data.value
			this.captureDepartmentTreeContext(data, node)
			this.currentDepartmentName = data.label || data.name || ''
			// 向上寻找当前节点所属的学校ID
			let schoolId = 0;
			let tempNode = node;
			while (tempNode) {
				if (tempNode.data && (tempNode.data.DeptOrgType === 'school' || tempNode.data.DeptOrgType === 'affiliateschool')) {
					schoolId = tempNode.data.value;
					break;
				}
				if (tempNode !== node || tempNode.level === 1) {
					if (tempNode.level === 2 || tempNode.level === 1) {
						schoolId = tempNode.data.value;
						break;
					}
				}
				tempNode = tempNode.parent;
			}
			this.SchoolId = schoolId || data.value;
			this.handleQuery()
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},
		formatCreateTime: function (row, column) {
			return !row.CreateTime || row.CreateTime == ''
				? ''
				: util.formatDate.format(
					new Date(row.CreateTime),
					'yyyy-MM-dd hh:mm:ss'
				)
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},
		load(tree, treeNode, resolve) {
			let para = {
				page: this.page,
				f: tree.Id,
				key: this.filters.Name,
				departmentId: this.DepartmentId,
			}
			getDeptVideoRecordListPage(para).then((res) => {
				resolve(res.data.response)
			})
		},
		//获取列表
		handleQuery() {
			let para = {
				page: this.page,
				departmentId: this.DepartmentId,
				...this.filters,
			}
			this.listLoading = true

			//NProgress.start();
			getDeptVideoRecordListPage(para).then(async (res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				const rows = res.data.response.data || []
				await this.prefetchListOssMedia(rows, 'CoverFile')
				this.users = rows
				this.listLoading = false
				//NProgress.done();
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//显示编辑界面
		handleEdit() {
			var row = this.multipleSelection
			if (row.length == 0 || row.length > 1) {
				this.$message({
					message: '请选择一行数据进行编辑！',
					type: 'error',
				})
				return
			}
			this.revokePendingVideoLocal()
			this.editForm = Object.assign({}, row[0])
			if (this.editForm.Dids) {
				this.$set(this.editForm, 'Dids', this.sanitizeDeptCascaderIds(this.editForm.Dids));
			} else {
				this.$set(this.editForm, 'Dids', []);
			}
			this.videoUrl = this.editForm.VideoFile
			this.imageUrl = this.editForm.CoverFile
			this.deferredImageInit('cover', this.editForm.CoverFile)
			this.editFormVisible = true
			this.$nextTick(() => this.refreshVideoPlaySrc())

			this.options = []
			this.initDeptFormSelection('edit', row[0].DepartmentId, row[0].Dids).then((path) => {
				this.applyDeptCascaderPath(this.editForm, path)
			}).catch(() => {})
		},
		//显示新增界面
		handleAdd() {
			if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
				this.$message.warning("请先在左侧选择具体的学校机构！");
				return;
			}
			this.revokePendingVideoLocal()
			this.videoUrl = ''
			this.addForm = {
				Title: '',           // 标题
				Content: '',         // 内容
				Type: 1,             // 类型，默认1通知
				IsPublish: true,     // 是否发布
				Sort: 1,             // 排序
				VideoFile: '',       // 视频文件（上传后赋值）
				CoverFile: '',       // 封面文件（上传后赋值）
				Dids: [],
				DepartmentId: ''
			}
			this.videoUrl = ''
			this.imageUrl = ''
			this.deferredImageRevoke('cover')
			if (!this.getSchoolIdForDeptCascader()) {
				this.$message.warning("请先在顶部切换学校！");
				return;
			}
			this.options = []
			this.initDeptFormSelection('add', this.DepartmentId).then((path) => {
				this.addFormVisible = true
				this.applyDeptCascaderPath(this.addForm, path)
			}).catch(() => {})
		},
		handleCoverChange(file) {
			this.deferredImageChange('cover', file, { foo: 'DeptVideoRecord', savedUrl: this.imageUrl })
		},
		quillSuccess(response) {
			if (response.success) {
				// 获取文本编辑器
				const quill = this.$refs.myQuillEditor.quill
				// 获取光标位置
				const pos = quill.getSelection().index
				// 插入图片到光标位置
				quill.insertEmbed(pos, 'image', this.$resolveImageSrc(response.response))
			} else {
				this.$message({
					message: response.msg,
					type: 'error',
				})
			}
		},
		beforeVideoUpload(file) {
			const isLt100M = file.size / 1024 / 1024 < 100
			if (!isLt100M) {
				this.$message.error('上传视频大小不能超过 100MB!')
				return false
			}
			return true
		},
		//编辑
		editSubmit: function () {
			const hasVideo = this.pendingVideoFile || (this.videoUrl || '').trim()
			if (!hasVideo) {
				this.$message.error('请选择视频');
				return;
			}
			if (!this.deferredImageDisplay('cover', this.imageUrl)) {
				this.$message.error('请上传封面');
				return;
			}

			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(async () => {
						this.editLoading = true
						if (this.pendingVideoFile) beginVideoUploadProgress(this)
						try {
							this.videoUrl = await ensureVideoUploaded(
								this.DepartmentId,
								this.pendingVideoFile,
								this.videoUrl,
								'DeptVideoRecord',
								createVideoUploadProgressHandlers(this)
							)
							this.revokePendingVideoLocal()
							await this.refreshVideoPlaySrc()
						} catch (e) {
							this.editLoading = false
							endVideoUploadProgress(this)
							this.$message.error((e && e.message) || '视频上传失败')
							return
						} finally {
							endVideoUploadProgress(this)
						}
						this.editForm.VideoFile = this.videoUrl
						this.editForm.CoverFile = await this.deferredImageEnsure('cover', { foo: 'DeptVideoRecord', currentUrl: this.editForm.CoverFile })
						let para = Object.assign({}, this.editForm)
						para.DepartmentId = para.Dids.pop();
						editDeptVideoRecord(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.editLoading = false
								return
							}
							if (res.data.success) {
								this.editLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['editForm'].resetFields()
								this.editFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
								this.editLoading = false
							}
						})
					})
				}
			})
		},
		//新增
		addSubmit: function () {
			const hasVideo = this.pendingVideoFile || (this.videoUrl || '').trim()
			if (!hasVideo) {
				this.$message.error('请选择视频');
				return;
			}
			if (!this.deferredImageDisplay('cover', this.imageUrl)) {
				this.$message.error('请上传封面');
				return;
			}

			let _this = this
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(async () => {
						this.addLoading = true
						if (this.pendingVideoFile) beginVideoUploadProgress(this)
						try {
							this.videoUrl = await ensureVideoUploaded(
								this.DepartmentId,
								this.pendingVideoFile,
								this.videoUrl,
								'DeptVideoRecord',
								createVideoUploadProgressHandlers(this)
							)
							this.revokePendingVideoLocal()
							await this.refreshVideoPlaySrc()
						} catch (e) {
							this.addLoading = false
							endVideoUploadProgress(this)
							this.$message.error((e && e.message) || '视频上传失败')
							return
						} finally {
							endVideoUploadProgress(this)
						}
						this.addForm.VideoFile = this.videoUrl
						this.addForm.CoverFile = await this.deferredImageEnsure('cover', { foo: 'DeptVideoRecord', currentUrl: this.addForm.CoverFile })
						let para = Object.assign({}, this.addForm)
						para.DepartmentId = para.Dids.pop();
						var user = JSON.parse(window.localStorage.user)
						if (user && user.uID > 0) {
							para.CreateUser = user.uRealName
						} else {
							this.$message({
								message: '用户信息为空，先登录',
								type: 'error',
							})
							_this.$router.replace(
								_this.$route.query.redirect ? _this.$route.query.redirect : '/'
							)
						}

						addDeptVideoRecord(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.addLoading = false
								return
							}

							if (res.data.success) {
								this.addLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['addForm'].resetFields()
								this.addFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
								this.addLoading = false
							}
						})
					})
				}
			})
		},
		//删除
		handleDel() {
			let row = this.multipleSelection
			if (row.length == 0) {
				this.$message({
					message: '请选择要删除的数据！',
					type: 'error',
				})

				return
			}
			this.$confirm('确认删除记录吗?', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					var ids = this.multipleSelection.map((item) => {
						return item.Id
					})
					var b = ids.join(',')
					let para = { ids: b }
					deleteDeptVideoRecord(para).then((res) => {
						if (util.isEmt.format(res)) {
							this.listLoading = false
							return
						}
						this.listLoading = false
						//NProgress.done();
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}

						this.handleQuery()
					})
				})
				.catch(() => { })
		},
		// 格式化部门名称：只保留路径的最后两级
		formatDepartmentNameCol(row, column, cellValue) {
			if (!cellValue) return '';
			const parts = cellValue.split('/');
			if (parts.length > 2) {
				return parts.slice(-2).join('/');
			}
			return cellValue;
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
	},
}
</script>

<style scoped less>
.custom-tbl /deep/ .has-gutter .el-checkbox {
	display: none;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 106.8px;
	line-height: 106.8px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 106.8px;
	display: block;
}

.avatar-uploader-tip {
	position: absolute;
	width: 100%;
	height: 1vw;
	bottom: 20px;
	color: gray;
	z-index: 99;
}
</style>